import { useEffect, useState } from 'react';

const CursorSpotlight = () => {
  const [pos, setPos] = useState({ x: 0, y: 0 });
  const [visible, setVisible] = useState(false);
  const [isTouch, setIsTouch] = useState(false);

  useEffect(() => {
    // Detect touch device
    const checkTouch = () => {
      if ('ontouchstart' in window) setIsTouch(true);
    };
    checkTouch();

    const handleMove = (e: MouseEvent) => {
      setPos({ x: e.clientX, y: e.clientY });
      setVisible(true);
    };

    const handleLeave = () => setVisible(false);

    if (!isTouch) {
      window.addEventListener('mousemove', handleMove);
      document.addEventListener('mouseleave', handleLeave);
    }

    return () => {
      window.removeEventListener('mousemove', handleMove);
      document.removeEventListener('mouseleave', handleLeave);
    };
  }, [isTouch]);

  if (isTouch || !visible) return null;

  return (
    <div
      className="pointer-events-none fixed inset-0 z-30 transition-opacity duration-300"
      style={{
        opacity: 0.7,
        background: `radial-gradient(circle 220px at ${pos.x}px ${pos.y}px, transparent 0%, transparent 40%, hsl(var(--background) / 0.15) 100%)`,
      }}
    />
  );
};

export default CursorSpotlight;
